/* CardX Redesign – Produktseite
   24.10.2026: Custom Commander auf Bestellung (cc): Status „wird für dich zusammengestellt“, Mengenbegrenzung und
   Zusatzinfo „Lieferzeit“ (data-cx-cc-prop) je nach gewählter Ausführung. */
(() => {
  'use strict';

  const T = window.CXTheme || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const formatMoney = T.formatMoney || ((c) => (Number(c) / 100).toFixed(2).replace('.', ',') + ' €');
  const scrollToSlide = (gallery, slide) =>
    gallery.scrollTo({ left: slide.offsetLeft - gallery.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });

  function initProduct(section) {
    if (section.dataset.cxReady) return;
    section.dataset.cxReady = '1';
    const dataEl = $('[data-cx-variants]', section);
    const form = $('[data-cx-product-form]', section);
    if (!dataEl || !form) return;
    let variants = [];
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    const groups = $$('[data-cx-option]', section);
    const idInput = $('[data-cx-variant-id]', form);
    const addButtons = $$('[data-cx-add]', section);
    const priceEls = $$('[data-cx-price-current]', section);
    const compareEls = $$('[data-cx-price-compare]', section);
    const stockEl = $('[data-cx-stock]', section);
    const qtyInput = $('[data-cx-qty-input]', form);
    const gallery = $('[data-cx-gallery-track]', section);
    const deliveryText = section.dataset.cxDelivery || '';
    const ccOrderText = section.dataset.cxCcOrder || '';
    const ccProp = $('[data-cx-cc-prop]', form);
    const isCcOrder = (v) => Boolean(v && v.cc && v.inventory_quantity <= 0);

    const selected = () =>
      groups.map((g) => {
        const checked = $('input:checked', g);
        return checked ? checked.value : null;
      });

    const markAvailability = (current) => {
      groups.forEach((group, index) => {
        $$('input', group).forEach((input) => {
          const ok = variants.some(
            (v) => v.available && v.options[index] === input.value && v.options.every((o, j) => j === index || o === current[j])
          );
          const pill = input.closest('.cx-pill');
          if (pill) pill.classList.toggle('is-unavailable', !ok);
        });
      });
    };

    const setStock = (variant) => {
      if (!stockEl) return;
      let state = 'ok';
      let text = 'Auf Lager' + (deliveryText ? ' – ' + deliveryText : '');
      if (!variant || !variant.available) {
        state = 'out';
        text = variant ? 'Ausverkauft' : 'Diese Kombination ist nicht verfügbar';
      } else if (isCcOrder(variant) && ccOrderText) {
        state = 'order';
        text = ccOrderText;
      } else if (variant.tracked && variant.inventory_quantity > 0 && variant.inventory_quantity <= 5) {
        state = 'low';
        text = 'Nur noch ' + variant.inventory_quantity + ' verfügbar' + (deliveryText ? ' – ' + deliveryText : '');
      }
      stockEl.dataset.state = state;
      const label = $('[data-cx-stock-text]', stockEl);
      if (label) label.textContent = text;
    };

    const update = (pushUrl) => {
      const current = selected();
      const variant = groups.length
        ? variants.find((v) => v.options.every((o, i) => o === current[i]))
        : variants.find((v) => String(v.id) === String(idInput.value)) || variants[0];
      markAvailability(current);
      groups.forEach((g, i) => {
        const out = $('[data-cx-option-value]', g);
        if (out) out.textContent = current[i] || '';
      });
      if (variant) {
        idInput.value = variant.id;
        priceEls.forEach((el) => (el.textContent = formatMoney(variant.price)));
        compareEls.forEach((el) => {
          const sale = variant.compare_at_price && variant.compare_at_price > variant.price;
          el.textContent = sale ? formatMoney(variant.compare_at_price) : '';
          el.hidden = !sale;
        });
        if (qtyInput) {
          if (variant.tracked && variant.deny) qtyInput.max = Math.max(1, variant.inventory_quantity);
          else if (variant.cc) qtyInput.max = Math.max(1, variant.inventory_quantity > 0 ? variant.inventory_quantity : variant.cc_left);
          else qtyInput.removeAttribute('max');
          if (qtyInput.max && Number(qtyInput.value) > Number(qtyInput.max)) qtyInput.value = qtyInput.max;
        }
        if (pushUrl && variant.media_id && gallery) {
          const slide = $('[data-media-id="' + variant.media_id + '"]', gallery);
          if (slide) scrollToSlide(gallery, slide);
        }
        if (pushUrl && window.history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      if (ccProp) ccProp.disabled = !isCcOrder(variant);
      const available = Boolean(variant && variant.available);
      addButtons.forEach((btn) => {
        btn.disabled = !available;
        btn.dataset.soldout = String(!available);
        const label = $('[data-cx-add-label]', btn);
        if (label) label.textContent = available ? 'In den Warenkorb' : variant ? 'Ausverkauft' : 'Nicht verfügbar';
      });
      setStock(variant);
    };

    groups.forEach((g) => g.addEventListener('change', () => update(true)));
    update(false);

    $$('[data-cx-thumb]', section).forEach((thumb) =>
      thumb.addEventListener('click', () => {
        const slide = gallery && $('[data-media-id="' + thumb.dataset.cxThumb + '"]', gallery);
        if (slide) scrollToSlide(gallery, slide);
      })
    );
    if (gallery) {
      const thumbs = $$('[data-cx-thumb]', section);
      const dots = $$('[data-cx-dot]', section);
      gallery.addEventListener(
        'scroll',
        () =>
          requestAnimationFrame(() => {
            const index = Math.round(gallery.scrollLeft / Math.max(1, gallery.clientWidth));
            thumbs.forEach((t, i) => t.setAttribute('aria-current', String(i === index)));
            dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
          }),
        { passive: true }
      );
    }

    /* Mobile Kaufleiste: erscheint, sobald der Haupt-Kaufbutton nach oben aus dem Bild gescrollt ist */
    const sticky = $('[data-cx-sticky-buy]', section);
    const mainButton = $('[data-cx-add-main]', section);
    if (sticky && mainButton) {
      let ticking = false;
      const check = () => {
        ticking = false;
        sticky.classList.toggle('is-visible', mainButton.getBoundingClientRect().bottom < 0);
      };
      const onScroll = () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(check);
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      check();
      const stickyButton = $('[data-cx-sticky-submit]', sticky);
      if (stickyButton) {
        stickyButton.addEventListener('click', () => {
          if (form.requestSubmit) form.requestSubmit();
          else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        });
      }
    }
  }

  const run = () => $$('[data-cx-product]').forEach(initProduct);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', (e) => $$('[data-cx-product]', e.target).forEach(initProduct));
})();